import {registerPaymentMethod} from '@woocommerce/blocks-registry';
import {getSettings} from "../util";
import {LocalPaymentIntentContent} from './local-payment-method';
import {PaymentMethodLabel, PaymentMethod} from "../../components/checkout";
import {canMakePayment} from "./local-payment-method";

const getData = getSettings('stripe_amazonpay_data');

if (getData()) {
    registerPaymentMethod({
        name: getData('name'),
        label: <PaymentMethodLabel
            title={getData('title')}
            paymentMethod={getData('name')}
            icons={getData('icon')}/>,
        ariaLabel: 'Ideal',
        placeOrderButtonLabel: getData('placeOrderButtonLabel'),
        canMakePayment: canMakePayment(getData, ({settings, billingAddress, cartTotals}) => {
            const {currency_code: currency} = cartTotals;
            const account_countries = getData('accountCountries');
            const accepted_currencies = getData('acceptedCurrencies');
            const account_country = getData('accountCountry');

            let result = false;

            // Check if account_country exists in the account_countries array
            if (account_countries.includes(account_country)) {
                // Check if the currency matches the expected currency for the account country
                if (accepted_currencies.hasOwnProperty(account_country)) {
                    result = accepted_currencies[account_country].includes(currency);
                } else {
                    result = true;
                }
            }

            return result;
        }),
        content: <PaymentMethod content={LocalPaymentIntentContent} getData={getData}/>,
        edit: <PaymentMethod content={LocalPaymentIntentContent} getData={getData}/>,
        supports: {
            showSavedCards: false,
            showSaveOption: false,
            features: getData('features')
        }
    })
}